import { OverviewComponent } from '@io/application/overview/overview.component';

import { Component, inject, OnInit } from '@angular/core';

import { ApContentService } from '@ap/content';

import content from './hypotheken-renteoverzicht.content.json';

@Component({
    selector: 'hypotheken-renteoverzicht',
    templateUrl: './hypotheken-renteoverzicht.component.html',
    imports: [OverviewComponent],
    standalone: true
})
export class HypothekenRenteoverzichtComponent implements OnInit {
    private readonly contentService = inject(ApContentService);

    ngOnInit() {
        this.contentService.addContentItems(content);
    }
}
